import { render, staticRenderFns } from "./ActivityThanks.vue?vue&type=template&id=5f75dff5&scoped=true"
import script from "./ActivityThanks.vue?vue&type=script&lang=js"
export * from "./ActivityThanks.vue?vue&type=script&lang=js"
import style0 from "./ActivityThanks.vue?vue&type=style&index=0&id=5f75dff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f75dff5",
  null
  
)

export default component.exports